export class ColumnSettingsBase {
    constructor(
        public readonly id: number,
        public readonly columnName,
        public readonly filterType,
        public readonly formatter,
        public translateKey,
        public readonly type,
        public readonly visibility,
        public readonly width,
        public readonly position,
        public readonly edit?,
        public readonly excelCellBlock?,
        public readonly group?,
        public readonly descriptionVisibility?,
        public readonly descriptionKey?,

        ) {
    }
}

export class WebTableSettings {
    constructor(
        public readonly moduleName: string,
        public readonly tableName: string,
        public readonly columns: ColumnSettingsBase[]
    ) {
    }
}


export class StocksColumnSettingsBase {
    constructor(
        public readonly id: number,
        public readonly columnName,
        public readonly filterType,
        public readonly formatter,
        public translateKey,
        public readonly type,
        public readonly visibility,
        public readonly descriptionVisibility,
        public readonly descriptionKey,
        public readonly group
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/column-settings-base.ts